import { util } from 'pevueglobal'

const state = {
  countries: []
}

// getters
const getters = {
  countries: state => state.countries
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [35, 36, 117, 118, 923, 924, 925, 2061, 4913, 4914, 14508]
    dispatch('gettranslations', textIDs, { root: true })
  },
  initCountries: async ({ commit }) => {
    const isLoggedIn = await util.isLoggedIn()
    const data = await util.getDataApi(`${isLoggedIn ? 'allroles' : 'public'}/PEapi_GetCountries`)
    
    commit('setCountries', data.ds.data0)
  }
}

// mutations
const mutations = {
  setCountries(state, countries) {
    state.countries = countries
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
